import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { buttonVariants } from '@speaking-coach/ui'

/**
 * The shared ending for provisioning create forms.
 *
 * Cancel is deliberately first in DOM/focus order, followed by any secondary
 * create action and finally the primary commit. Because Cancel is a router
 * link, the page's UnsavedChangesGuard handles it exactly like the breadcrumb
 * and shell close action.
 */
export function ProvisioningFormActions({
  cancelTo,
  children,
  help,
}: {
  cancelTo: string
  children: ReactNode
  help?: ReactNode
}): JSX.Element {
  return (
    <div className="mt-6 border-t border-border-default pt-4">
      <div
        role="group"
        aria-label="Form actions"
        className="flex flex-wrap items-center justify-end gap-2"
      >
        <Link
          to={cancelTo}
          className={buttonVariants({ variant: 'secondary' })}
        >
          Cancel
        </Link>
        {children}
      </div>
      {help !== undefined && (
        <div className="mt-2 text-right text-caption text-text-secondary">
          {help}
        </div>
      )}
    </div>
  )
}
